module.exports = __webpack_public_path__ + "static/img/6.63d643e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/6.jpg
// module id = 424
// module chunks = 1